module.exports = __webpack_public_path__ + "img/android-install-step-3.b1d7be19.svg";